import { render, staticRenderFns } from "./PolicyTableBody.vue?vue&type=template&id=f1141f0a&"
import script from "./PolicyTableBody.vue?vue&type=script&lang=js&"
export * from "./PolicyTableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports